import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'GESTAO_VM_MOTIVO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('gestaoVMMotivoForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'GESTAO_VM_MOTIVO_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'GESTAO_VM_MOTIVO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(documentos) {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'GESTAO_VM_MOTIVO_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/gestaoVMMotivo`).then(resp => {
			dispatch({
		        type: 'GESTAO_VM_MOTIVO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
	return async (dispatch, getState) => {
		if (!registro.id) {
			await axios.post(`${consts.API_URL}/gestaoVMMotivo`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/gestaoVMMotivo`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
	};
}

export function excluir(registro, evento) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/gestaoVMMotivo?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}